import { favouritesAxiosInstance as network } from '../../axios';
import { Endpoints, SiteTypes } from '../../enums';
import { GenericResponse } from '../../types';
import { endpointReplace } from '../../utils/endpointReplace';
import { getAuthenticationConfig } from '../../utils/getAuthenticationConfig';

export const deleteItemFromList = async (listId: string, itemId: string) => {
  const path = endpointReplace(
    { ':siteType': SiteTypes.FAVOURITES, ':listId': listId, ':itemId': itemId },
    Endpoints.RemoveItemFromFavourites,
  );

  const authentication = await getAuthenticationConfig();

  const response = await network.delete<GenericResponse>(path, authentication);

  return response.data;
};
